import { render, staticRenderFns } from "./editCwvDomainCard.vue?vue&type=template&id=60e2e35a"
import script from "./editCwvDomainCard.vue?vue&type=script&lang=ts"
export * from "./editCwvDomainCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports